import { render, staticRenderFns } from "./ProductListItem.vue?vue&type=template&id=6d158482&scoped=true"
import script from "./ProductListItem.vue?vue&type=script&lang=ts"
export * from "./ProductListItem.vue?vue&type=script&lang=ts"
import style0 from "./ProductListItem.vue?vue&type=style&index=0&id=6d158482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d158482",
  null
  
)

export default component.exports